{
  "sdk-download-android": "Tải xuống cho Android",
  "sdk-connect": "Kết nối",
  "sdk-download-ios": "Tải xuống cho iOS",
  "sdk-install": "Cài đặt",
  "sdk-modal-instruct-1": "1. Mở ứng dụng Binance",
  "sdk-modal-instruct-2": "2. Nhấn vào {{icon}} trên Màn hình chính",
  "sdk-modal-title": "Kết nối với Binance",
  "sdk-no-app": "Bạn chưa có ứng dụng Binance?"
}